<div class="floating-theme-selector" 
     [class.dragging]="isDragging">
  
  <!-- Botón principal flotante en esquina inferior izquierda -->
  <div class="floating-toggle-btn" 
       (mousedown)="onMouseDown($event)"
       (click)="toggleSelector()"
       [style.background-color]="getCurrentThemeColor()"
       [attr.aria-label]="'Cambiar tema - Actual: ' + getCurrentThemeDisplayName()">
    <!-- Icono de herramienta en lugar del icono original -->
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.32 9.55l-1.89-.63.89-1.78A1 1 0 0 0 20.13 6L18 3.87a1 1 0 0 0-1.15-.3l-1.78.89-.63-1.89A1 1 0 0 0 13.5 2h-3a1 1 0 0 0-.95.68l-.63 1.89-1.78-.89A1 1 0 0 0 6 3.87L3.87 6a1 1 0 0 0-.3 1.15l.89 1.78-1.89.63A1 1 0 0 0 2 10.5v3a1 1 0 0 0 .68.95l1.89.63-.89 1.78A1 1 0 0 0 3.87 18L6 20.13a1 1 0 0 0 1.15.3l1.78-.89.63 1.89a1 1 0 0 0 .95.68h3a1 1 0 0 0 .95-.68l.63-1.89 1.78.89A1 1 0 0 0 18 20.13L20.13 18a1 1 0 0 0 .3-1.15l-.89-1.78 1.89-.63A1 1 0 0 0 22 13.5v-3a1 1 0 0 0-.68-.95zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" fill="currentColor"/>
    </svg>
    
    <!-- Eliminado el nombre del tema y el indicador de arrastre para simplificar -->
  </div>

  <!-- Dropdown de temas (sin cambios) -->
  <div class="theme-dropdown" [class.open]="isOpen" [class.opens-upward]="opensUpward">
    <div class="theme-dropdown-content">
      <div class="theme-dropdown-header">
        <h4 class="theme-dropdown-title">🎨 Seleccionar Tema</h4>
        <button class="close-btn" (click)="toggleSelector()" aria-label="Cerrar selector">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>
      
      <div class="theme-options">
        <button 
          *ngFor="let theme of themes" 
          class="theme-option"
          [class.active]="theme.name === currentTheme"
          (click)="selectTheme(theme.name)"
          [attr.aria-label]="'Cambiar a tema ' + theme.displayName"
        >
          <div class="theme-preview" [style.background-color]="theme.colors.primary">
            <div class="theme-preview-accent" [style.background-color]="theme.colors.accent"></div>
            <div class="theme-preview-secondary" [style.background-color]="theme.colors.secondary"></div>
          </div>
          <div class="theme-info">
            <span class="theme-display-name">{{ theme.displayName }}</span>
            <span class="theme-description">{{ getThemeDescription(theme.name) }}</span>
          </div>
          <div class="theme-check" *ngIf="theme.name === currentTheme">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/>
            </svg>
          </div>
        </button>
        
        <!-- Botón para tema personalizado -->
        <button 
          class="theme-option custom-theme-option"
          (click)="openCustomThemeModal()"
          [attr.aria-label]="'Crear tema personalizado'"
        >
          <div class="theme-preview custom-preview">
            <div class="custom-icon">🎨</div>
          </div>
          <div class="theme-info">
            <span class="theme-display-name">Personalizado</span>
            <span class="theme-description">Personalizar con tus colores</span>
          </div>
          <div class="theme-arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
            </svg>
          </div>
        </button>
      </div>
    
    </div>
  </div>

  <!-- Overlay para cerrar el selector -->
  <div class="theme-overlay" *ngIf="isOpen" (click)="toggleSelector()"></div>
  
  <!-- Modal de tema personalizado -->
  <app-custom-theme-modal></app-custom-theme-modal>
</div>